/**
 *
 * @author Aleynikov Boris <aleynikov.boris@gmail.com>.
 */

'use strict';

module.exports = function ( app ) {
    var ts       = require('../ts')(app),
        gettext  = require('mag-gettext').gettext;

    /*eslint max-len:0*/
    return {
        id: 'timeShiftBufferMode',
        name: gettext('Using buffer mode'),
        description: gettext('There are two options for using the buffer. Cyclic overwrite - recording to the buffer is performed cyclically. Once the buffer is full, the new record overwrites the existing ones. Stop when filled - the record ends once the storage space is filled.'),
        icon: 'theme-icon-categories',
        data: {
            timeShiftBufferCyclicMode: false
        },
        saveImmediate: true,
        prepareForRender: function ( currentValue, callback ) {
            var data = [
                {name: gettext('Cyclic record mode'), value: true},
                {name: gettext('Stop when out of space'), value: false}
            ];

            data.forEach(function ( item ) {
                item.selected = item.value === currentValue.timeShiftBufferCyclicMode;
            });

            callback(data);
        },
        prepareForSave: function ( value, callback ) {
            this.data.timeShiftBufferCyclicMode = value;

            ts.cyclic = value;
            callback();
        },
        render: app.api.renders.popupSelect,
        parent: 'timeshift'
    };
};
